import { maxAgeSec } from '@shared/constants/nextCookies'

// Variation and Control Group Constants
export const VARIATION_GROUP = 'variation'
export const CONTROL_GROUP = 'control'

export type ServerExperiment = {
  cookiePctKey: string
  cookieGroupKey: string
  expKey: string
  envVariableExpPct: string | undefined
  // undefined implies all users
  userType?: 'logged_in'
  // cookie lifetime in seconds, defaults to 2 hours if not set
  maxAgeSec?: number
  // when true, only re bucket when env pct changes to 0 for users
  // already in the variation group. control users are not sticky
  // and may be updated to variation as the rollout increases. pct
  // increases/decreases are ignored for already bucketed users.
  stickyBucketing?: boolean
}

export const SHOP_DEALS_APP_ROUTER: ServerExperiment = {
  cookiePctKey: 'deals_app_router_pct',
  cookieGroupKey: 'deals_app_router_group',
  expKey: 'exp_deals_app_router',
  maxAgeSec,
  stickyBucketing: true,
  get envVariableExpPct() {
    return process.env.DEALS_APP_ROUTER_PCT
  },
}

export const serverSideExperiments: ServerExperiment[] = [SHOP_DEALS_APP_ROUTER]

export const getServerExperimentPct = ({
  envVariableExpPct,
}: ServerExperiment): number | undefined => {
  if (!envVariableExpPct) return undefined
  const pct = Number(envVariableExpPct)
  return Number.isNaN(pct) ? undefined : pct
}

export const isServerExperimentEnabled = (experiment: ServerExperiment) =>
  (getServerExperimentPct(experiment) ?? 0) > 0
